import { render, staticRenderFns } from "./send-code.vue?vue&type=template&id=d3b62572&scoped=true&"
import script from "./send-code.vue?vue&type=script&lang=js&"
export * from "./send-code.vue?vue&type=script&lang=js&"
import style0 from "./send-code.vue?vue&type=style&index=0&id=d3b62572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b62572",
  null
  
)

export default component.exports